import axios from 'axios'
import store from './../../store'
import router from '../../router'
//import NProgress from 'nprogress' // 进度条
import url from './url'
import {
  Notification,
  MessageBox,
  Loading
} from 'element-ui'
//axios.defaults.baseURL = '/api/'+config.appCode; // 公共请求地址(云部署配置）
axios.defaults.baseURL = '/api' // 单机部署配置
// axios.interceptors.request.header('Access-Control-Allow-Headers', 'Content-Type', 'Content-Length', 'Authorization', 'Accept', 'X-Requested-With', 'yourHeaderFeild');
// 发起请求时,会执行该方法
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
}
// 默认携带Cookie
axios.defaults.withCredentials = true;
let loadingInstance = null;
let isloading = false;
let count = 0 // 统计接口status:"notAuth"的统计次数

axios.interceptors.request.use(config => {
  // store.commit('ifLoading', true)
  //NProgress.start()
  if (config.url.indexOf("signInByQrCode") == -1) {
    isloading = false;
  } else {
    isloading = true;
  }
  if (config.url.indexOf("getPayStatus") != -1 || config.url.indexOf("orderInfo/pay") != -1 || config.url.indexOf("/getBSCPayStatus") != -1 || config.url.indexOf("/rechargePay") != -1) {
    isloading = true;
  }

  if (!isloading) {
    loadingInstance = Loading.service({
      lock: true,
      // text: 'Loading',
      // spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }

  config.headers.appVersion = "3.1.5"; // 根据实际情况自行修改
  config.headers.platformType = "pc";
  //access_token: this.$store.getters.AppInfo.accessToken,
  // if(this.$store.getters.AppInfo.accessToken){
  //     config.headers.Authorization = 'Bearer '+ this.$store.getters.AppInfo.accessToken;
  // }
  //你可以在这里开始加载动画,  查询token  等等之类

  return config
}, err => {
  console.log(err, "err")
  return Promise.reject(err)
})

//接收到后台的数据时执行的方法
axios.interceptors.response.use(response => {
  return response
}, err => {
  //NProgress.done()
    const { status } = err.response;
    if(status){
        const errorText = codeMessage[status]
        Notification.warning({
          title: status,
          message:  `${errorText}`,
        })
    } else {
      Notification.warning({
				title: '警告',
				message: '网络错误，请检查你的网络',
			})
    }
    if (loadingInstance) loadingInstance.close();
		store.commit('zoomLoadingCount', 0)
})
//检查状态码 status

function checkStatus(res) {
  if (!isloading) loadingInstance.close();

  if (!res) {
    return;
  }
  if ((res.status === 200 || res.status === 304) && res.data.status == "success") { //当状态正常是返回原样的数据
    return res.data.data
  } else {
    if (res.data.data === 'NotLoginException') {
      Notification.warning({
        title: '警告',
        message: '账号已在其他设备登陆，如果不是本人操作请修改密码'
      })
      router.push('/ssoLogin')
    } else if (res.data.status === "accountAmountInsufficient") {
      return res.data;
    } else if (res.data.data === "IllegalArgumentException") {
      Notification.error({
        title: '错误',
        message: res.data.message || res.data.msg || '未知异常'
      })
      return false
    } else if (res.data.status === 'notAuth') {
      count++
      if (count == 1) {
        MessageBox.confirm('您的权限已发生变更，请切换门店或重新登录获取最新权限。', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '确定',
          type: 'warning'
        }).then(() => {
          axios.get(url.logout, {
            headers: {
              'accesstoken': store.getters.AppInfo ? store.getters.AppInfo.accessToken : ''
            }
          }).then(() => {
            //NProgress.done()
            if (!isloading) loadingInstance.close();
            router.push('/ssoLogin')
            count = 0
          })
        }).catch(() => {
          count = 0
        });
      }
    } else if (res.data.data == "OrderPayException") {
      localStorage.removeItem("newTradeNoPwdFlag")
      Notification.error({
        title: '错误',
        message: res.data.message || res.data.msg || '未知异常'
      })
      return false
    } else {
      if ((res.data.data == "NotLoginException")) {
        router.push('/ssoLogin');
      } else {
        if (!isloading) Notification.error({
          title: '错误',
          message: res.data.message || res.data.msg || '未知异常'
        })
      }
      //router.push('/ssoLogin')
      if (isloading) return res.data
      return false // 状态不正常时可以返回自己自定义的一些格式或者状态什么的
    }
  }
}
// loadingInstance = Loading.service({
//     lock: true,
//     // text: '加载中...',
//     // spinner: 'el-icon-loading',
//     spinner: '../images/home/loading.gif',
//     background: 'rgba(0, 0, 0, 0.7)'
// });
// setTimeout(() => {
//     loadingInstance.close();
// }, 1000)
export default {
  error(message) {
    Notification.error({
      title: '错误',
      message: (message || '未知异常')
    })
  },
  file(url, data) {

    if (!url) return
    return axios({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 10000
    }).then(checkStatus).catch(res => {

      Notification.error({
        title: '错误',
        message: res
      })
      return false
    })
  },
  success(message) {
    if (!isloading) loadingInstance.close();
    Notification.success({
      title: '成功',
      message: (message || '操作成功')
    });
  },
  get(url, params = {}) { //返回封装后的 get 方法
    if (!url) return
    //params.access_token = store.getters.AppInfo.accessToken;
    let headToken = '';
    if (url != '/merchant/verifyCode/sendNoLogin' && url != '/merchant/kaptcha/getImg') {
      //headToken = store.getters.AppInfo.accessToken;
    }
    return axios({
      method: 'get',
      url,
      params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'accesstoken': store.getters.AppInfo ? store.getters.AppInfo.accessToken : '',
        //'content-type': 'application/json;charset=UTF-8'
      },
      timeout: 10000
    }).then(checkStatus).catch(res => {
      if (!isloading) loadingInstance.close();
      store.commit('ifLoading', false)

      // Notification.error({
      //     title: '错误',
      //     message: res
      // })
      return false
    })
  },
  post(url, data = {}) { //返回封装后的 post 方法
    if (!url) return
    let headToken = '';
    if (url != '/merchant/login/signIn' && url != '/merchant/member/register' && url != '/merchant/kaptcha/getImg') {
      //headToken = store.getters.AppInfo.accessToken;
    }
    //data.access_token = store.getters.AppInfo.accessToken;
    return axios({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'accesstoken': store.getters.AppInfo ? store.getters.AppInfo.accessToken : '',
        //'access_token': headToken,
      },
      timeout: 30000
    }).then(checkStatus).catch(res => {
      if (!isloading) loadingInstance.close();
      store.commit('ifLoading', false)
      // Notification.error({
      //     title: '错误',
      //     message: res
      // })
      return false
    })
  }
}